document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mg-menu-toggle');
  const menu = document.querySelector('#MgMenu');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
